/**
 * Custom error class for handling redirects in try-catch blocks.
 * This allows us to throw a redirect intention in a try block and handle it in the catch.
 */
export class RedirectError extends Error {
  constructor(public readonly path: string) {
    super(`Redirect to ${path}`)
    this.name = 'RedirectError'
  }
}

/**
 * Helper function to throw a redirect error.
 * Use this instead of redirect() when inside a try block.
 */
export const throwRedirect = (path: string): never => {
  throw new RedirectError(path)
}

/**
 * Type guard to check if an error is a RedirectError
 */
export const isRedirectError = (error: unknown): error is RedirectError => {
  return error instanceof RedirectError
}
